import React from "react";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { DropdownValue } from ".";
import Text from "../../../styleguide/Text";
import clsx from "clsx";
import LoadingIndicator from "../LoadingIndicator";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const classes = clsx("form-control form-control-solid mb-3 mb-lg-0");

export default function MultipleDropdown({
  data,
  multipleValues,
  setMultipleValues,
  name,
  title = " ",
  className,
  style,
  placeholder,
  isLoading,
  disabled,
  withVerticalSpacer,
}: {
  data: DropdownValue[];
  multipleValues?: DropdownValue[];
  setMultipleValues?: (value: DropdownValue[]) => void;
  name?: string;
  title?: string;
  className?: string;
  style?: React.CSSProperties;
  placeholder?: string;
  isLoading?: boolean;
  disabled?: boolean;
  withVerticalSpacer?: boolean;
}) {
  const handleOnSelect = (_: any, values: any) => {
    if (values && setMultipleValues) {
      setMultipleValues(values);
    }
  };
  return (
    <div
      className={`fv-row mb-7 w-100 ${
        withVerticalSpacer ? "px-1" : ""
      } ${className}`}>
      {title && (
        <label
          htmlFor={`${name ?? title}-multiple-checkbox-label`}
          className="form-label fs-6 fw-bolder text-dark">
          <Text variant="body1" isBold>
            {title}
          </Text>
        </label>
      )}
      <Autocomplete
        multiple
        id={`${name ?? title}-multiple-checkbox-label`}
        style={style}
        fullWidth
        disabled={disabled}
        options={data}
        value={multipleValues ?? []}
        disableCloseOnSelect
        loading={isLoading}
        onChange={handleOnSelect}
        getOptionLabel={(option) => option.label.toString()}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        renderOption={(props, option, { selected }) => (
          <li {...props} key={option.id}>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 8 }}
              checked={selected}
            />
            {option.label}
          </li>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            className={classes}
            sx={{
              "& fieldset": { border: "none" },
            }}
            placeholder={placeholder}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {isLoading ? (
                    <LoadingIndicator color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
    </div>
  );
}
